import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import meteor from './../../../images/404/meteor.svg';
import astronaut from './../../../images/404/astronaut.svg';
import spaceship from './../../../images/404/spaceship.svg';

class PageNotFound extends Component {
  render() {
    return (
      <div className="section">
        <div className="mars" />
        {/* <img src={mars} className="logo-404" alt="404" /> */}
        <img src={meteor} className="meteor" alt="meteor" />
        <p className="title">Oh no!!</p>
        <p className="subtitle">
          {/* You’re either misspelling the URL <br /> or requesting a page that's
          no longer here. */}
          SLT Broadband Portal has been upgraded to a new version <br />
          including many new features, please click below.
        </p>
        <div align="center">
          <Link className="btn-back" to="/dashboard">
            Back To Dashboard
          </Link>
        </div>
        <img src={astronaut} className="astronaut" alt="astronaut" />
        <img src={spaceship} className="spaceship" alt="spaceship" />
      </div>
    );
  }
}

export default PageNotFound;
